import React, { useEffect, useRef, useState } from "react";
import Tabs from "../../../components/Tabs/Tab";
import { Dropdown } from "../../../components/DropDown/DropDown";
import Icons from "../../../components/Icons/Icon";
import ClockInOut from "./ClockInOut";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getTeamsAsync,
  getUserProfileAsync,
} from "../../../services/reducers/appReducer";
import { formatDate } from "../../../utils/common";
import {
  getTeamClockInOutAsync,
  getTeamListAsync,
  getTeamListsAsync,
  getTeamScreenShotsAsync,
  getTimeSpentListAsync,
} from "../../../services/reducers/teamsReducer";
import {
  getOrganizationListAsync,
  getReportAsync,
} from "../../../services/reducers/adminReducer";
import { useDebounce } from "../../../utils/hooks/useDebounce";
import RadioButton from "../../../components/Radio button/RadioButton";
import { Modal, ModalBody, ModalFooter } from "../../../components/Modal/Modal";
import Button from "../../../components/Button/Button";
import SearchBarMedium from "../../../components/SearchBar/SearchBarMedium";
import TeamScreenshots from "./TeamScreenshots";
import ToggleButton from "../../../components/ToogleButton/ToogleButton";

export const EchoPulseDatePicker = styled.div`
  overflow: hidden;
  .react-datepicker__calendar-icon {
    display: none;
  }

  // .react-datepicker-wrapper {
  //   width: 9.5rem;
  // }

  .react-datepicker-wrapper input {
    padding: 0.531rem 0.625rem;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    color: #232323;
    border: 0.063rem solid #d9d9d9;
    border-radius: 0.375rem;
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z' fill='%23292D32'/%3E%3Cpath d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z' fill='%23292D32'/%3E%3Cpath d='M20.5 9.83997H3.5C3.09 9.83997 2.75 9.49997 2.75 9.08997C2.75 8.67997 3.09 8.33997 3.5 8.33997H20.5C20.91 8.33997 21.25 8.67997 21.25 9.08997C21.25 9.49997 20.91 9.83997 20.5 9.83997Z' fill='%23292D32'/%3E%3Cpath d='M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z' fill='%23292D32'/%3E%3Cpath d='M8.5 14.5C8.37 14.5 8.24 14.47 8.12 14.42C8 14.37 7.89001 14.3 7.79001 14.21C7.70001 14.11 7.62999 14 7.57999 13.88C7.52999 13.76 7.5 13.63 7.5 13.5C7.5 13.24 7.61001 12.98 7.79001 12.79C7.89001 12.7 8 12.63 8.12 12.58C8.3 12.5 8.50001 12.48 8.70001 12.52C8.76001 12.53 8.82 12.55 8.88 12.58C8.94 12.6 9 12.63 9.06 12.67C9.11 12.71 9.15999 12.75 9.20999 12.79C9.24999 12.84 9.29999 12.89 9.32999 12.94C9.36999 13 9.40001 13.06 9.42001 13.12C9.45001 13.18 9.47001 13.24 9.48001 13.3C9.49001 13.37 9.5 13.43 9.5 13.5C9.5 13.76 9.38999 14.02 9.20999 14.21C9.01999 14.39 8.76 14.5 8.5 14.5Z' fill='%23292D32'/%3E%3Cpath d='M12 14.5C11.74 14.5 11.48 14.39 11.29 14.21C11.25 14.16 11.21 14.11 11.17 14.06C11.13 14 11.1 13.94 11.08 13.88C11.05 13.82 11.03 13.76 11.02 13.7C11.01 13.63 11 13.57 11 13.5C11 13.37 11.03 13.24 11.08 13.12C11.13 13 11.2 12.89 11.29 12.79C11.57 12.51 12.02 12.42 12.38 12.58C12.51 12.63 12.61 12.7 12.71 12.79C12.89 12.98 13 13.24 13 13.5C13 13.57 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.82 12.92 13.88C12.9 13.94 12.87 14 12.83 14.06C12.79 14.11 12.75 14.16 12.71 14.21C12.61 14.3 12.51 14.37 12.38 14.42C12.26 14.47 12.13 14.5 12 14.5Z' fill='%23292D32'/%3E%3Cpath d='M8.5 18C8.37 18 8.24 17.97 8.12 17.92C8 17.87 7.89001 17.8 7.79001 17.71C7.70001 17.61 7.62999 17.51 7.57999 17.38C7.52999 17.26 7.5 17.13 7.5 17C7.5 16.74 7.61001 16.48 7.79001 16.29C7.89001 16.2 8 16.13 8.12 16.08C8.49 15.92 8.92999 16.01 9.20999 16.29C9.24999 16.34 9.29999 16.39 9.32999 16.44C9.36999 16.5 9.40001 16.56 9.42001 16.62C9.45001 16.68 9.47001 16.74 9.48001 16.81C9.49001 16.87 9.5 16.94 9.5 17C9.5 17.26 9.38999 17.52 9.20999 17.71C9.01999 17.89 8.76 18 8.5 18Z' fill='%23292D32'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 93%;
    background-position-y: center;
    cursor: pointer;
  }

  .react-datepicker-wrapper input:focus {
    border: 0.063rem solid #4a154b;
    box-shadow: 0 0.625rem 1.25rem 0 rgba(0, 0, 0, 0.08);
    outline: 0;
  }
  .monthlyDate .react-datepicker-popper {
    width: max-content;
  }
  .monthlyDate .react-datepicker__month-text {
    padding: 0.9rem 0;
    width: 5.1rem;
    display: inline-block;
    font-size: 0.875rem;
    margin: 0.125rem;
  }
  .monthlyDate .react-datepicker__month-text--keyboard-selected {
    background-color: #f8f8f8;
    color: #000;
    font-weight: bolder;
  }
  .monthlyDate .react-datepicker__header {
    background-color: #fff;
    border: none;
    padding-top: 1.25rem;
  }
  .monthlyDate .react-datepicker__navigation {
    align-items: center;
    display: flex;
    padding: 0;
    text-align: center;
    top: 1.063rem;
  }
  .monthlyDate .react-datepicker__navigation--previous {
    left: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation--next {
    rigth: 0.4375rem;
  }
  .monthlyDate .react-datepicker__navigation-icon:before {
    border-color: #232323;
    border-width: 0.094rem 0.094rem 0 0;
  }
  .monthlyDate .react-datepicker__day--in-range {
    background-color: #f15845;
  }
  .monthlyDate .react-datepicker__day--keyboard-selected {
    // color: #fff;
  }
  .monthlyDate .react-datepicker__day--today {
    font-weight: 800;
  }
 .react-datepicker__day--selected.react-datepicker__day--today{
  color: #fff
  }
  .react-datepicker__day--in-range.react-datepicker__day--in-range {
  color: #fff
  }
  .react-datepicker__month-text--in-range {
    background-color: #f15845;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #ffffff;
  }
  .react-datepicker__day--selected {
    background-color: #f15845;
  }
  .timesheetDate {
    input {
      width: 2.5rem;
      height: 2.5rem;
      font-size: 0;
      background-position: center;
    }
  }
`;

type TeamOption = {
  value: string;
  label: string;
};

const Teams = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
  const [startDate2, setStartDate2] = useState(startOfWeek);
  const [endDate2, setEndDate2] = useState(() => {
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(endOfWeek.getDate() + 6);
    return endOfWeek;
  });
  const [searchStringTab3, setSearchStringTab3] = useState("");
  const [screenSearch, setScreenSearch] = useState("");
  const dispatch = useAppDispatch();
  const { teamsList } = useAppSelector((state: any) => state.app);
  const [optionsTeam, setOptionsTeam] = useState<TeamOption[]>([]);
  const [selectedTeam, setSelectedTeam] = useState<any>(
    optionsTeam[0] ? optionsTeam[0] : ""
  );
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("tab1");
  const [currentPage1, setCurrentPage1] = useState(1);
  const [screenCurrentPage, setScreenCurrentPage] = useState(1);
  const [pageSize1, setPageSize1] = useState(50);
  const [screenPageSize, setScreenPageSize] = useState(8);
  const [filterss, setFilterss] = useState(false);
  const [clockLists, setClockLists] = useState<any>([]);
  const [screenShotLists, setScreenShotLists] = useState<any>([]);
  const [clockTimeLog, setClockTimeLog] = useState<any>([]);
  const [count, setCount] = useState<any>([]);
  const [screenCount, setScreenCount] = useState<any>([]);
  const [filterss1, setFilterss1] = useState(false);
  const [isConfirmationVisible, setConfirmationVisible] = useState(false);
  const [selectedRequestType, setSelectedRequestType] = useState("");
  const [screenFilterss, setScreenFilterss] = useState(false);
  const [startDaily, setStartDaily] = useState(new Date());
  const [clockLog, setClockLog] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState("Active");
  const [timeOffLog, setTimeOffLog] = useState<any>([]);
  const { userProfile } = useAppSelector((state: any) => state.app);
  const [isMyTeamSelected, setIsMyTeamSelected] = useState(false);
  const [isMyScreenshotSelected, setIsMyScreenshotSelected] = useState(false);
  const isFetching = useRef(false);
  const [isTaskLoading, setIsTaskLoading] = useState<boolean>(false);
  const [isRMs, setIsRMs] = useState(false);

  const filterFutureDates = (date: Date) => {
    const today = new Date();
    return date <= today;
  };

  const onChangeDate = (value: any) => {
    if (!value || !value[0]) {
      return;
    }
    const selectedDate = value[0];
    if (!selectedDate || typeof selectedDate.getDay !== "function") {
      return;
    }
    const dayOfWeek = selectedDate.getDay();
    const startOfWeek = new Date(selectedDate);
    startOfWeek.setDate(selectedDate.getDate() - ((dayOfWeek + 6) % 7));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    setStartDate2(startOfWeek);
    setEndDate2(endOfWeek);
  };

  useEffect(() => {
    if (isFetching.current) return;

    isFetching.current = true;
    const teamsReqBody = {};
    if (teamsList.length === 0) {
      dispatch(getTeamsAsync(teamsReqBody)).then((res) => {
        if (!!res?.payload && res?.payload?.length > 0) {
          const teams = res?.payload?.map((item: any) => {
            return { value: item.key, label: item.value };
          });

          const allOption = {
            value: "all",
            label: "All Teams",
          };
          const optionsWithAll = [allOption, ...teams];
          setOptionsTeam(optionsWithAll);
          setSelectedTeam(optionsWithAll[0]);
          isFetching.current = false;
        }
      });
    } else {
      if (!!teamsList && teamsList?.length > 0) {
        const teams = teamsList?.map((item: any) => {
          return { value: item.key, label: item.value };
        });
        const allOption = {
          value: "all",
          label: "All Teams",
        };
        const optionsWithAll = [allOption, ...teams];
        setOptionsTeam(optionsWithAll);
        setSelectedTeam(optionsWithAll[0]);
        isFetching.current = false;
      }
    }
  }, []);

  useEffect(() => {
    // dispatch(getOrganizationListAsync());
    dispatch(getUserProfileAsync());
  }, []);

  const clockList = () => {
    // if (isFetching.current) return; 

    // isFetching.current = true;
    setLoading(true);
    const isReportingManager = userProfile?.isReportingManager;
    const isAdmin = userProfile?.roleName === "Admin";
    const isEmployee = userProfile?.roleName === "Employee";

    let isRM = false;

    if (isReportingManager && isAdmin && isMyTeamSelected) {
      isRM = true;
    } else if (isReportingManager && isEmployee) {
      isRM = true;
    }

    const request: any = {
      startDate: formatDate(startDate2),
      endDate: formatDate(endDate2),
      team:
        selectedTeam?.label && selectedTeam?.label !== "All Teams"
          ? selectedTeam?.label
          : "",
      memberName: searchStringTab3,
      Page: currentPage1,
      PageSize: pageSize1,
      memberStatus: selectedStatus === "Active" ? "Active" : "Inactive",
      isRM: isRM,
    };

    request.SelectedStartDate = formatDate(startDate2);
    request.SelectedEndDate = formatDate(endDate2);

    dispatch(getTeamListsAsync(request)).then((res) => {
      setCount(res.payload.item1);
      const filteredList =
        res.payload &&
        res.payload.item2.map((record: any) => {
          const filteredTasks = record.timeLogs.filter((task: any) => {
            const recordDate = new Date(task.date);

            const isAfterStartDate2 = recordDate >= startDate2;

            const isBeforeEndDate2 = recordDate <= endDate2;

            return isAfterStartDate2 && isBeforeEndDate2;
          });

          return {
            ...record,
            tasksList: filteredTasks,
          };
        });

      setClockLists(filteredList);
      setClockTimeLog(filteredList.flatMap((t: any) => t.timeLogs));
      setClockLog(filteredList.flatMap((t: any) => t.clockLogs));
      setTimeOffLog(filteredList.flatMap((t: any) => t.timeOffLogs));
      setLoading(false);
      // isFetching.current = false;
    });
  };

  const debouncedTeamTimesheet = useDebounce(clockList, 1000);

  useEffect(() => {
    if (activeTab === "tab1") {
      debouncedTeamTimesheet();
    }
  }, [
    activeTab,
    startDate2,
    endDate2,
    searchStringTab3,
    selectedTeam,
    currentPage1,
    pageSize1,
    selectedStatus,
    isMyTeamSelected,
  ]);

  useEffect(() => {
    setCurrentPage1(1);
  }, [searchStringTab3, selectedTeam, selectedStatus]);

  const handleDownload = () => {
    setIsTaskLoading(true);
    if (selectedRequestType === "CurrentMonth") {
      const currentDate = new Date();
      const startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
      const request: any = {
        StartDate: formatDate(startDate),
        EndDate: formatDate(endDate),
      };
      dispatch(getReportAsync(request)).then((res) => {
        if (res.payload) {
          const csvData = res.payload;
          const blob = new Blob([csvData], { type: "text/csv" });
          const fileName = `data_${formatDate(startDate)}_to_${formatDate(
            endDate
          )}.csv`;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        setIsTaskLoading(false);
        setConfirmationVisible(false);

      });
    } else if (selectedRequestType === "PreviousMonth") {
      const currentDate = new Date();
      const startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      const request: any = {
        StartDate: formatDate(startDate),
        EndDate: formatDate(endDate),
      };
      dispatch(getReportAsync(request)).then((res) => {
        if (res.payload) {
          const csvData = res.payload;
          const blob = new Blob([csvData], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const fileName = `data_${formatDate(startDate)}_to_${formatDate(
            endDate
          )}.csv`;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        setIsTaskLoading(false);
        setConfirmationVisible(false);
      });
    }
  };

  const screenshotList = () => {
    setLoading(true);
    const isReportingManager = userProfile?.isReportingManager;
    const isAdmin = userProfile?.roleName === "Admin";
    const isEmployee = userProfile?.roleName === "Employee";

    let isRM = false;

    if (isReportingManager && isAdmin && isMyScreenshotSelected) {
      isRM = true;
    } else if (isReportingManager && isEmployee) {
      isRM = true;
    }
    const request: any = {
      startDate: formatDate(startDaily),
      memberName: screenSearch,
      Page: screenCurrentPage,
      PageSize: screenPageSize,
      isRM: isRM,
    };

    dispatch(getTeamScreenShotsAsync(request)).then((res) => {
      setScreenCount(res.payload.item1);
      setScreenShotLists(res.payload.item2);
      setLoading(false);
    });
  };

  const debouncedTeamScreenshot = useDebounce(screenshotList, 1000);
  useEffect(() => {
    if (activeTab === "tab2") {
      debouncedTeamScreenshot();
    }
  }, [
    activeTab,
    startDaily,
    screenSearch,
    screenCurrentPage,
    screenPageSize,
    isMyScreenshotSelected,
  ]);

  useEffect(() => {
    setScreenCurrentPage(1);
  }, [screenSearch]);

  const handleStatusChange = (selectedValue: any) => {
    setSelectedStatus(selectedValue.value);
  };

  // const handleToggleChange = () => {
  //   setIsMyTeamSelected(!isMyTeamSelected);
  //   setSelectedTeam(optionsTeam[0]);
  //   setSearchStringTab3("");
  //   setSelectedStatus("Active")
  // };
  const handleToggleChange = () => {
    const newIsMyTeamSelected = !isMyTeamSelected;
    setIsMyTeamSelected(newIsMyTeamSelected);
    setSelectedTeam(optionsTeam[0]);
    setSearchStringTab3("");
    setSelectedStatus("Active");
    localStorage.setItem('isMyTeamSelected', JSON.stringify(newIsMyTeamSelected));
  };

  useEffect(() => {
    const savedIsMyTeamSelected = JSON.parse(localStorage.getItem('isMyTeamSelected') || 'false');
    setIsMyTeamSelected(savedIsMyTeamSelected);
  }, []);

  const handleScreenToggleChange = () => {
    setIsMyScreenshotSelected(!isMyScreenshotSelected);
    setScreenSearch("");
  };

  useEffect(() => {
    const isReportingManager = userProfile?.isReportingManager;
    const isAdmin = userProfile?.roleName === "Admin";
    const isEmployee = userProfile?.roleName === "Employee";

    setIsRMs((isReportingManager && isAdmin && isMyTeamSelected) || (isReportingManager && isEmployee));
  }, [isMyTeamSelected]);

  return (
    <div className="pt-2" id="adminTeams">
      <div className="w-full">
        <Tabs
          onClick={(id) => setActiveTab(id)}
          size="md"
          tabs={[
            {
              content: (
                <div className="relative">
                  <ClockInOut
                    clockLists={clockLists}
                    loading={loading}
                    clockTimeLog={clockTimeLog}
                    currentPage={currentPage1}
                    pageSize={pageSize1}
                    count={count}
                    setFilterss={setFilterss1}
                    filterss={filterss1}
                    setCurrentPage={setCurrentPage1}
                    clockLog={clockLog}
                    timeOffLog={timeOffLog}
                  />

                  <div className="absolute -top-[3.313rem] right-0 flex justify-end items-center gap-2.5">
                    {userProfile?.roleName === "Admin" &&
                      userProfile?.isReportingManager && (
                        <div className="flex justify-end items-center gap-1.5 [&>label>span.ml-2]:m-0">
                          <div className="text-300 text-black font-normal">
                            All
                          </div>
                          <ToggleButton
                            className=""
                            label=""
                            onChange={handleToggleChange}
                            type="timeOff"
                            defaultChecked={isMyTeamSelected}
                          />
                          <div className="text-300 text-black font-bold">
                            My Team
                          </div>
                        </div>
                      )}
                    <div className="w-[6.5rem]">
                      <Dropdown
                        value={{
                          label:
                            selectedStatus === "Active" ? "Active" : "Inactive",
                          value: selectedStatus,
                        }}
                        placeholder="Select"
                        onChange={(selectedValue) =>
                          handleStatusChange(selectedValue)
                        }
                        options={[
                          {
                            label: "Active",
                            value: "Active",
                          },
                          {
                            label: "Inactive",
                            value: "Inactive",
                          },
                        ]}
                        type="mdbox"
                      />
                    </div>
                    <EchoPulseDatePicker>
                      <div className="monthlyDate timesheetDate">
                        <DatePicker
                          selectsRange={true}
                          startDate={startDate2}
                          endDate={endDate2}
                          onChange={onChangeDate}
                          dateFormat="dd MMM"
                          showIcon
                          filterDate={filterFutureDates}
                          onFocus={(e: any) => e.target.blur()}
                        />
                      </div>
                    </EchoPulseDatePicker>
                    <div className="w-[8.5rem]">
                      <Dropdown
                        className=""
                        onChange={(selectedOption) => {
                          setFilterss(true);
                          setSelectedTeam(selectedOption);
                        }}
                        placeholder="Select"
                        options={optionsTeam}
                        type="mdbox"
                        value={selectedTeam}
                      />
                    </div>
                    <div className="w-[14rem]">
                      <SearchBarMedium
                        value={searchStringTab3 ? searchStringTab3 : ""}
                        placeholder="Search employee "
                        icon={
                          <Icons name="search" variant="stroke" size={14} />
                        }
                        onChange={(e) =>
                          setSearchStringTab3 &&
                          setSearchStringTab3(e.target.value)
                        }
                      />
                    </div>

                    {!isRMs && (
                      <div>
                        <button
                          onClick={() => setConfirmationVisible(true)}
                          className="flex justify-start items-center gap-2 text-400 transition-all rounded-md font-bold hover:shadow-100 disabled:bg-primary-300 disabled:shadow-0
               bg-primary-100 text-white hover:bg-primary-200 px-4 py-2.5"
                        >
                          <Icons
                            className="[&>svg>path]:fill-white"
                            name="import"
                            variant="stroke"
                            size={16}
                          />
                          <span>Report</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ),
              id: "tab1",
              label: "Team Timesheets",
            },

            {
              content: (
                <div className="relative">
                  <TeamScreenshots
                    currentPage={screenCurrentPage}
                    pageSize={screenPageSize}
                    teamCount={screenCount}
                    setFilterss={setScreenFilterss}
                    filterss={screenFilterss}
                    setCurrentPage={setScreenCurrentPage}
                    screenShotLists={screenShotLists}
                    loading={loading}
                    startDaily={formatDate(startDaily)}
                  />

                  <div className="absolute -top-[3.313rem] right-0 flex justify-end items-center gap-2.5">
                    {userProfile?.roleName === "Admin" &&
                      userProfile?.isReportingManager && (
                        <div className="flex justify-end items-center gap-1.5 [&>label>span.ml-2]:m-0">
                          <div className="text-300 text-black font-normal">
                            All
                          </div>
                          <ToggleButton
                            className=""
                            label=""
                            onChange={handleScreenToggleChange}
                            type="timeOff"
                            defaultChecked={isMyScreenshotSelected}
                          />
                          <div className="text-300 text-black font-bold">
                            My Team
                          </div>
                        </div>
                      )}
                    <div className="w-[14rem]">
                      <SearchBarMedium
                        value={screenSearch ? screenSearch : ""}
                        placeholder="Search employee"
                        icon={
                          <Icons name="search" variant="stroke" size={14} />
                        }
                        onChange={(e) =>
                          setScreenSearch && setScreenSearch(e.target.value)
                        }
                      />
                    </div>
                    <EchoPulseDatePicker>
                      <div className="w-[8rem] monthlyDate">
                        <DatePicker
                          selected={startDaily}
                          onChange={(date: Date) => setStartDaily(date)}
                          dateFormat="dd MMM yyyy"
                          showIcon
                          filterDate={filterFutureDates}
                          onFocus={(e: any) => e.target.blur()}
                        />
                      </div>
                    </EchoPulseDatePicker>
                  </div>
                </div>
              ),
              id: "tab2",
              label: "Team’s Screenshots",
            },

          ]}
        />
      </div>
      {isConfirmationVisible && (
        <div>
          <Modal
            isOpen={true}
            onClose={() => {
              setConfirmationVisible(false);
            }}
            size="small"
          >
            <ModalBody className="px-10 pe-14 pt-10 pb-[3rem]">
              <p className="text-gray-300 font-semibold text-500">
                {" "}
                {"Select Month for Report Export "}
              </p>
              <p className="text-gray-700 font-normal text-400 mt-1.5">
                {" "}
                {
                  "Choose the month for which you require the timesheet report. The report will be generated in CSV format."
                }
              </p>

              <div className="mt-5">
                <RadioButton
                  name="requestType"
                  label="Current Month"
                  value="CurrentMonth"
                  selectedValue={selectedRequestType}
                  onChange={() => setSelectedRequestType("CurrentMonth")}
                  size="sm"
                />
              </div>
              <div className="mt-1">
                <RadioButton
                  name="requestType"
                  label="Previous Month"
                  value="PreviousMonth"
                  selectedValue={selectedRequestType}
                  onChange={() => setSelectedRequestType("PreviousMonth")}
                  size="sm"
                />
              </div>
            </ModalBody>
            <ModalFooter className="!px-10 gap-2.5 bg-gray-200 !flex !justify-between !items-center">
              {/* <p className="text-gray-300 font-normal text-200"> </p> */}
              {/* <Button
                label="Download"
                onClick={() => handleDownload()}
                variant="primary"
                size="large"
              /> */}

              <button
                onClick={() => handleDownload()}
                disabled={isTaskLoading || selectedRequestType === ""}
                className="flex justify-center items-center gap-2 transition-all button relative rounded-md font-bold hover:shadow-100 disabled:bg-primary-300 disabled:shadow-0 bg-primary-100 text-white hover:bg-primary-200 text-500 px-6 py-[0.688rem]"
              >
                {isTaskLoading && (
                  <span>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="#D9D9D9"
                        stroke-width="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="#FFF"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  </span>
                )}
                <span>Download</span>
              </button>

            </ModalFooter>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default Teams;
